import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HOST_TOKEN } from "../config/token.ts";

export default function useLogin() {
  const [email, setEmail] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      const authService =
        (
          await import(
            "service1/authService"
          )
        ).default;

      const data =
        await authService.login(
          { email },
          HOST_TOKEN
        );

      //  Navigate only when valid
      if (data.statusType === 1) {
        sessionStorage.setItem(
          "userId",
          data.userId || ""
        );

        navigate("/password", {
          state: { name: data.name },
        });
      } else {
        // Stay on same page
        console.log("Invalid email");
      }
    } catch (err) {
      console.error("API Error:", err);
    }
  };

  return {
    email,
    setEmail,
    handleSubmit,
    isValid: email.includes("@"),
  };
}